import { render, staticRenderFns } from "./QuoNonProp.vue?vue&type=template&id=3981a42e&scoped=true&"
import script from "./QuoNonProp.vue?vue&type=script&lang=js&"
export * from "./QuoNonProp.vue?vue&type=script&lang=js&"
import style0 from "./QuoNonProp.vue?vue&type=style&index=0&id=3981a42e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3981a42e",
  null
  
)

export default component.exports